import { checkBackendHealth } from '../lib/api';

export const check_is_active = async () => {
  const isConnected = await checkBackendHealth();
  if (!isConnected) {
    console.error('backend not connected!');
  }
};
